import _ from 'lodash';
import { SubmissionError } from 'redux-form';
import * as actions from 'app/actions/account-settings';
import * as client from 'app/api/contentful-client';

export const sendInvites = (values, afterComplete) => ({
  promise: async (http) => {
    const emails = values.email.split(',').map(e => e.trim());

    const machineInvitations = _(emails)
      .map(email => values.machines.map(machine => ({
        email,
        machine_serial: machine.serial,
        machine_name: machine.machineName,
        roles: machine.roles,
        grants: machine.grants })))
      .flatten()
      .value();

    const result = await http.post(
      '/user/v1/machine_invitations',
      { machine_invitations: machineInvitations },
    );

    if (afterComplete) afterComplete(result);
  },
  events: [
    'PROMISE_PENDING',
    actions.SET_INVITES_SENT,
    actions.SET_INVITE_ERROR,
  ],
});

export const toggleMachinesForUser = (email, machines, initialMachines, afterComplete) => {
  const serializeMachine = m => ({
    email,
    machine_id: m.serial,
    machine_name: m.machineName,
    roles: m.roles,
  });
  const updatedMachines = _.map(machines, serializeMachine);
  const originalMachines = _.map(initialMachines, serializeMachine);

  // Add machines when there is a new serial
  const addedMachines = _.differenceBy(updatedMachines, originalMachines, m => m.machine_id);
  // Remove machines only when the serial doesn't exist at all in the new list
  const removedMachines = _.differenceBy(originalMachines, updatedMachines, m => m.machine_id);
  // Modify machines when an existing serial has a change in values
  // final machines
  // - identical to initial machines
  // - newly added machines
  // = modified machines
  const modifiedMachines =
    _.differenceBy(
      _.differenceWith(updatedMachines, originalMachines, _.isEqual),
      addedMachines,
      m => m.machine_id);

  return {
    promise: async (http) => {
      const calls = [];
      if (!_.isEmpty(addedMachines)) {
        // Re-key machine_id to machine_serial
        const invitations = _.map(addedMachines, (m) => {
          const invitationMachine = {
            ...m,
            machine_serial: m.machine_id,
          };
          delete invitationMachine.machine_id;
          return invitationMachine;
        });
        calls.push(http.post(
          '/user/v1/machine_invitations',
          { machine_invitations: invitations },
        ));
      }
      if (!_.isEmpty(removedMachines)) {
        calls.push(await http.post(
          '/gfcore/users/remove_machine_access',
          { machine_users: removedMachines },
        ));
      }
      if (!_.isEmpty(modifiedMachines)) {
        calls.push(await http.post(
          '/gfcore/users/modify_machine_access',
          { machine_users: modifiedMachines },
        ));
      }

      await Promise.all(calls);

      afterComplete();
    },
    events: [
      'PROMISE_PENDING',
      actions.SET_ACCESS_UPDATED,
      actions.SET_ACCESS_UPDATED_ERROR,
    ],
  };
};

export const fetchPendingInvites = () => ({
  promise: http => http.get('/user/v1/machine_invitations'),
  events: ['PROMISE_PENDING', actions.SET_PENDING_INVITES, 'PROMISE_ERROR'],
});

export const fetchUserPaymentMathods = () => ({
  promise: http => http.get('/storefront/api/payment_methods'),
  events: ['PROMISE_PENDING', actions.SET_USER_PAYMENT_METHODS, 'PROMISE_ERROR'],
});

export const fetchUserPurchaseHistory = () => ({
  promise: http => http.get('/base://storefront/api/orders'),
  events: ['PROMISE_PENDING', actions.SET_USER_PURCHASE_HISTORY, 'PROMISE_ERROR'],
});

export const updateUserPaymentMethod = values => ({
  promise: http => http.put('/storefront/api/users/current', values).then((results) => {
    if (_.get(results, 'status') === 'error') {
      let ccSubmitError;
      if (_.get(results, 'errors.credit_card.base')) {
        // General Credit Card error
        ccSubmitError = _.get(results, 'errors.credit_card.base')[0];
      } else {
        ccSubmitError = 'There was an issue with your submission. Please try again later.';
      }
      throw new SubmissionError({ _error: ccSubmitError });
    }

    return results;
  }),
  events: ['PROMISE_PENDING', actions.UPDATE_CREDIT_CARD, actions.UPDATE_CREDIT_CARD_ERROR],
});

export const fetchUserSettingsPage = () => ({
  promise: () => client.getPage('user-account-settings'),
  events: ['PROMISE_PENDING', actions.SET_SETTINGS_PAGE, 'PROMISE_ERROR'],
});



// WEBPACK FOOTER //
// ./app/api/account-settings-api.js